//slider
$(function() {
'use strict';
//slider
var sliderOpt = {
	infinite: true,
	arrows: false,
	dots: false,
	autoplay: false,
	speed: 1000,
	slidesToShow: 4,
	slidesToScroll: 1,
	cssEase: 'ease-out',
	lazyLoad: 'progressive',
	pauseOnFocus: false,
	pauseOnHover: false,
	responsive: [{
		breakpoint: 768,
		settings: {
slidesToShow: 1,
	dots: true
		}
	}]
};
var slider = $('.slider').slick(sliderOpt);

});
